export default __webpack_public_path__ + "static/media/email-sent-blue.86891e55.svg";